import {
  clearSlackSigninState,
  completeSlackLoginFromCallback,
  readSlackSignInRequest,
  SlackSsoError,
  startSlackLogin,
} from '@/modules/auth/slackSso';
import { authProviders } from '@/modules/auth/types/externalLogin';

import { OAuthCallbackStatus } from './oauthCallbackStatus/OAuthCallbackStatus';
import {
  type OAuthCallbackAdapter,
  useOAuthCallback,
} from './oauthCallbackStatus/useOAuthCallback';

const slackCallback: OAuthCallbackAdapter = {
  provider: 'Slack',
  ssoEvent: 'slackSSO',
  ssoFailureReason: 'slack_sso_error',
  complete: async (callbackUrl) => {
    const { code, redirectUri, ...request } =
      await completeSlackLoginFromCallback(callbackUrl);
    return {
      request,
      credentials: {
        provider: authProviders.slack,
        authorizationCode: code,
        redirectUri,
        idToken: null,
      },
    };
  },
  readRequest: readSlackSignInRequest,
  clearState: clearSlackSigninState,
  start: ({ returnTo, acceptTerms, intent }) =>
    startSlackLogin(returnTo, acceptTerms, intent),
  getSsoErrorCode: (error) =>
    error instanceof SlackSsoError ? error.code : undefined,
};

/**
 * `/auth/callback/slack`: exchanges Slack's code through the API's external
 * login. Signing in with Slack doesn't connect Finlay's bot to the workspace;
 * that stays the separate Connect Slack step (`SlackCallback`).
 */
export const SlackSignInCallback = () => (
  <OAuthCallbackStatus provider="Slack" {...useOAuthCallback(slackCallback)} />
);
